import React, { useState } from 'react';
import { MapPinIcon, PillIcon, XIcon, ZapIcon } from 'lucide-react';
export function NearbyDealsWidget() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return <aside className="fixed bottom-[23rem] right-3 z-[60] w-[calc(100%-1.5rem)] overflow-hidden rounded-xl border border-gray-100 bg-white shadow-xl sm:bottom-[20rem] sm:right-6 sm:w-80" aria-label="Nearby pharmacy deals" data-id="element-133" data-mp="14sj24kobp85o">
      <div className="flex items-center justify-between bg-[#008F82] px-4 py-3 text-white" data-id="element-134" data-mp="d1d5wfbq3ulo">
        <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider" data-id="element-135" data-mp="83uy4s9fzlf9">
          <span className="relative grid h-5 w-5 place-items-center" aria-hidden="true" data-id="element-136" data-mp="m3301swzp7n5">
            <PillIcon className="absolute h-4 w-4" data-id="element-137" data-mp="h51g75rqp4am" />
            <ZapIcon className="absolute -right-1 -top-1 h-3 w-3 fill-[#E28743] text-[#E28743]" data-id="element-138" data-mp="1xfnbf1ug88n9" />
          </span>
          Nearby Rx Savings &amp; Sales
        </div>
        <button type="button" onClick={() => setVisible(false)} className="grid h-6 w-6 place-items-center rounded-md text-white/80 hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Close nearby deals" data-id="element-139" data-mp="3eahrza9kauv6">
          <XIcon className="h-4 w-4" data-id="element-140" data-mp="3s8y2lcajp5il" />
        </button>
      </div>
      <div className="space-y-3 p-4" data-id="element-141" data-mp="2umij64yk5xse">
        <div className="flex items-start justify-between gap-3" data-id="element-142" data-mp="2unjv0bneeob6">
          <p className="text-sm font-bold text-[#1C1C1C]" data-id="element-143" data-mp="2zl23y21f13j6">
            Northridge Family Pharmacy
          </p>
          <span className="shrink-0 rounded-full bg-[#A63A2B] px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-144" data-mp="34k50sz78s3g2">
            Active Sale
          </span>
        </div>
        <p className="text-sm font-semibold leading-5 text-[#1C1C1C]" data-id="element-145" data-mp="2bw0qu1hn147k">
          20% off all over-the-counter wellness &amp; vitamins
        </p>
        <p className="text-xs leading-5 text-[#6B6B6B]" data-id="element-146" data-mp="2gt9f8jtdq4h9">
          Valid for the next 4 hours. Verified by 6 community check-ins this
          morning.
        </p>
      </div>
      <div className="flex items-center justify-between gap-3 border-t border-gray-100 px-4 py-3 text-xs" data-id="element-147" data-mp="24rhtvnvl2qgr">
        <span className="inline-flex items-center gap-1 text-[#777]" data-id="element-148" data-mp="2iimlc2osscg0">
          <MapPinIcon className="h-3.5 w-3.5" data-id="element-149" data-mp="2dkcq5s32pbue" /> 0.8 miles away
        </span>
        <button type="button" className="font-semibold text-[#E28743] hover:text-[#C66D2E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E28743]" data-id="element-150" data-mp="1pvaagps01t2j">
          View all 4 local deals →
        </button>
      </div>
    </aside>;
}